import {User} from "./User";

export class CurrentUser extends User {
    urlRoot = '/api/v1/users/profile';
}


// WEBPACK FOOTER //
// ./srv/public/js/models/CurrentUser.ts